export const SmartLabelEnum = {
    MasterApplicationTitle: 'MasterApplicationTitle',
    MasterFooterCopyright: 'MasterFooterCopyright',
    MasterFooterInfo: 'MasterFooterInfo',
    MasterFooterLinks: 'MasterFooterLinks',
    MasterHeaderApplicationOffline: 'MasterHeaderApplicationOffline',
    MasterNavigationBarLogout: 'MasterNavigationBarLogout',
    RegistryIDLabel: 'RegistryIDLabel',
    TrainingProviderEventSortEventIdAscending: 'TrainingProviderEventSortEventIdAscending',
    TrainingProviderEventSortEventIdDescending: 'TrainingProviderEventSortEventIdDescending',
    TrainingProviderEventSortStartDateAscending: 'TrainingProviderEventSortStartDateAscending',
    TrainingProviderEventSortStartDateDescending: 'TrainingProviderEventSortStartDateDescending',
} as const;

export type SmartLabelEnum = typeof SmartLabelEnum[keyof typeof SmartLabelEnum];
